<script>
  import moment from "moment";

  export let startDate = 'startDate';
  export let endDate = 'endDate';
  export let minDate;
  export let maxDate;
  export let refreshCallback = () => {};
  export let defaultDaysRange = 30;

  function setDate(days) {
    if (days > -1) {
      startDate = moment().subtract(days, 'days').format('YYYY-MM-DD');
      endDate = maxDate;
    } else {
      startDate = 'startDate';
      endDate = 'endDate';
    }
  }

  setDate(defaultDaysRange);
</script>

<div class="pc-line">
  <span class="date-label">From</span>
  <input type="date" bind:value={startDate} class="form-control" min="{minDate}" max="{maxDate}" on:input={refreshCallback}>
</div>
<div class="pc-line">
  <span class="date-label">To</span>
  <input type="date" bind:value="{endDate}" class="form-control" min="{minDate}" max="{maxDate}" on:input={refreshCallback}>
</div>
<div class="pc-line">
  <button class="btn btn-primary btn-filter" on:click="{() => {setDate(0); refreshCallback()}}">Today</button>
  <button class="btn btn-primary btn-filter" on:click="{() => {setDate(6); refreshCallback()}}">Last week</button>
  <button class="btn btn-primary btn-filter" on:click="{() => {setDate(30); refreshCallback()}}">Last month</button>
  <button class="btn btn-primary btn-filter" on:click="{() => {setDate(-1); refreshCallback()}}">Reset</button>
</div>

<style>
  .buttons {
    margin-bottom: 15px;
  }

  .buttons .btn {
    margin-left: 5px;
  }

  .btn-primary.btn-filter {
    padding: 8px 20px;
  }

  .form-select, .form-control {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  input[type="date"] {
    width: auto;
    display: inline-block;
    vertical-align: top;
  }

  .date-label {
    padding: 0 5px;
    line-height: 38px;
    font-weight: 500;
  }

  .pc-line {
    display: inline-block;
    margin-bottom: 10px;
  }
</style>